import type { FC } from "react";

import {
  SCROLLABLE_SOCIAL_PROOF_CARDS_DEFAULTS,
  SCROLLABLE_SOCIAL_PROOF_CARDS_LIST_CLASS,
  type TScrollableSocialProofCardsProps,
} from "./ScrollableSocialProofCards.config";
import { Flex } from "@/ui/components/layout";
import { ScrollArea } from "@/ui/components/primitives";

import { SocialProofCard } from "../SocialProofCard";

export const ScrollableSocialProofCards: FC<TScrollableSocialProofCardsProps> = ({
  items,
  "data-component": component = SCROLLABLE_SOCIAL_PROOF_CARDS_DEFAULTS["data-component"],
}) => (
  <ScrollArea
    data-component={component}
    orientation="horizontal"
    className="w-full"
  >
    <Flex
      data-component="ScrollableSocialProofCardsList"
      className={SCROLLABLE_SOCIAL_PROOF_CARDS_LIST_CLASS}
      gap="4"
    >
      { items.map((item, index) => (
        <SocialProofCard key={`${item.author.name}-${index}`} { ...item } />
      )) }
    </Flex>
  </ScrollArea>
);

ScrollableSocialProofCards.displayName = "ScrollableSocialProofCards";
